import React, { useState } from 'react'
import { useDispatch, useStore, useSelector } from 'react-redux'
import { useHistory } from 'react-router-dom'
import IntlMessages from '../../util/IntlMessages'
import { Button, Row, Col, Modal, Form, List, Spin } from 'antd'
import ParkRetrieveListItem from './ParkRetrieveListItem'
import CustomScrollbars from '../../util/CustomScrollbars'
import { CloseOutlined } from '@ant-design/icons'

const ShowSaleDataModal = props => {
  const { getIsSpinning, showSale, changeShowModal, title } = props
  const dispatch = useDispatch()
  const saleAttribData = useSelector(
    ({ commonConfigs }) => commonConfigs.saleAttribData
  )

  return (
    <Modal
      transitionName=''
      maskTransitionName=''
      // className='fullfillment-modal'
      visible={showSale}
      onCancel={() => {
        changeShowModal()
      }}
      closeIcon={
        <Button
          size='large'
          className='modal-cross-btn'
          icon={<CloseOutlined />}
        />
      }
      title={`Parked sales ${title ? `on ${title}` : ''}`}
      footer={null}
      centered={true}
    >
      <Spin
        tip={<IntlMessages id='sell.cashlisting.cashloading' />}
        spinning={getIsSpinning} //getIsSpinning
        size='large'
      >
        {saleAttribData && saleAttribData.length > 2 ? (
          <CustomScrollbars className='gx-module-content-scroll'>
            <List
              // style={{ marginTop: 10 }}
              itemLayout='horizontal'
              // pagination={pagination}
              dataSource={saleAttribData}
              renderItem={retrieveItem => (
                <ParkRetrieveListItem
                  retrieveItem={retrieveItem}
                  // callBack={callBack}
                  type='showSale'
                />
              )}
            />
          </CustomScrollbars>
        ) : (
          <List
            // style={{ marginTop: 10 }}
            itemLayout='horizontal'
            // pagination={pagination}
            dataSource={saleAttribData}
            renderItem={retrieveItem => (
              <ParkRetrieveListItem
                retrieveItem={retrieveItem}
                // callBack={callBack}
                type='showSale'
              />
            )}
          />
        )}
      </Spin>
    </Modal>
  )
}

export default ShowSaleDataModal
